import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ShoppingCart } from 'lucide-react';
import { formatPrice } from '../../utils/formatters';

interface Order {
    order_number: string;
    customer_email: string;
    total_amount: number;
    status: string;
    created_at: number;
}

interface Props {
    ordersList: Order[];
}

const parseStatus = (statusString: string | null) => {
    if (!statusString) return { name: 'UNKNOWN', color: '#888888' };
    try {
        const parsed = JSON.parse(statusString);
        const name = Object.keys(parsed)[0] || 'UNKNOWN';
        const color = parsed[name] || '#888888';
        return { name, color };
    } catch (e) {
        return { name: statusString, color: '#ff0000' };
    }
};

const formatDate = (ts: number | null) => ts ? new Date(ts).toLocaleString('pl-PL') : 'Brak danych';

const OrdersTab: React.FC<Props> = ({ ordersList }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const adminPath = location.pathname.split('/')[1];

    return (
        <div className="w-full relative animate-fade-in">
            <div className="flex justify-between items-center mb-4">
                <h2 className="text-xl font-bold text-white flex items-center gap-2">
                    <ShoppingCart className="w-5 h-5" /> Orders
                </h2>
            </div>
            <div className="overflow-x-auto border border-gray-800 rounded-sm">
                <table className="w-full text-left border-collapse">
                    <thead className="bg-mystic-box">
                        <tr className="border-b border-gray-800 text-gray-500 text-[10px] uppercase font-bold tracking-wider">
                            <th className="p-2 border-r border-gray-800">Order #</th>
                            <th className="p-2 border-r border-gray-800">Date</th>
                            <th className="p-2 border-r border-gray-800">Customer</th>
                            <th className="p-2 border-r border-gray-800">Total</th>
                            <th className="p-2">Status</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-800 bg-mystic-bg">
                        {ordersList.map(order => {
                            const { name, color } = parseStatus(order.status);
                            return (
                            <tr key={order.order_number} className="group hover:bg-mystic-btn">
                                <td className="p-2 border-r border-gray-800 text-xs">
                                    <button onClick={() => navigate(`/${adminPath}/orders/${order.order_number}`)} className="text-mystic-accent font-bold hover:underline">
                                        {order.order_number}
                                    </button>
                                </td>
                                <td className="p-2 border-r border-gray-800 text-xs text-gray-400">{formatDate(order.created_at)}</td>
                                <td className="p-2 border-r border-gray-800 text-xs">{order.customer_email}</td>
                                <td className="p-2 border-r border-gray-800 text-xs text-white font-bold">{formatPrice(order.total_amount)} zł</td>
                                <td className="p-2 text-xs">
                                    <span 
                                        className="px-2 py-0.5 rounded-full border font-bold"
                                        style={{
                                            backgroundColor: `${color}20`,
                                            color: color,
                                            borderColor: `${color}80`,
                                        }}
                                    >
                                        {name}
                                    </span>
                                </td>
                            </tr>
                        )})}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default OrdersTab;